// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer defaults {
  :root {
    --readthedocs-font-family:
      "Lato", "proxima-nova", "Helvetica Neue", "Arial", sans-serif;
    --readthedocs-font-size: 1rem;
  }

  :root[data-readthedocs-tool="mkdocs-material"] {
    --readthedocs-font-size: 1.455em;
    --readthedocs-filetreediff-icon-width: 0.6rem;
  }

  :root[data-readthedocs-tool="zensical"] {
    --readthedocs-font-size: 1.455em;
    --readthedocs-filetreediff-icon-width: 0.6rem;
  }

  :root[data-readthedocs-tool="antora"] {
    --readthedocs-flyout-font-size: 0.7em;
    --readthedocs-notification-font-size: 0.75em;
  }

  :root[data-readthedocs-tool="mdbook"] {
    --readthedocs-font-size: 1.3rem;
  }

  :root[data-readthedocs-tool="sphinx"][data-readthedocs-tool-theme="furo"] {
    --readthedocs-font-size: 0.9em;
  }

  :root[data-readthedocs-tool="sphinx"][data-readthedocs-tool-theme="immaterial"] {
    --readthedocs-font-size: 1.45em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/defaults.css"],"names":[],"mappings":"AAAA;EACE;IACE;mEAC+D;IAC/D,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;IAChC,6CAA6C;EAC/C;;EAEA;IACE,gCAAgC;IAChC,6CAA6C;EAC/C;;EAEA;IACE,qCAAqC;IACrC,4CAA4C;EAC9C;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;EACjC;AACF","sourcesContent":["@layer defaults {\n  :root {\n    --readthedocs-font-family:\n      \"Lato\", \"proxima-nova\", \"Helvetica Neue\", \"Arial\", sans-serif;\n    --readthedocs-font-size: 1rem;\n  }\n\n  :root[data-readthedocs-tool=\"mkdocs-material\"] {\n    --readthedocs-font-size: 1.455em;\n    --readthedocs-filetreediff-icon-width: 0.6rem;\n  }\n\n  :root[data-readthedocs-tool=\"zensical\"] {\n    --readthedocs-font-size: 1.455em;\n    --readthedocs-filetreediff-icon-width: 0.6rem;\n  }\n\n  :root[data-readthedocs-tool=\"antora\"] {\n    --readthedocs-flyout-font-size: 0.7em;\n    --readthedocs-notification-font-size: 0.75em;\n  }\n\n  :root[data-readthedocs-tool=\"mdbook\"] {\n    --readthedocs-font-size: 1.3rem;\n  }\n\n  :root[data-readthedocs-tool=\"sphinx\"][data-readthedocs-tool-theme=\"furo\"] {\n    --readthedocs-font-size: 0.9em;\n  }\n\n  :root[data-readthedocs-tool=\"sphinx\"][data-readthedocs-tool-theme=\"immaterial\"] {\n    --readthedocs-font-size: 1.45em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
